var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.status)?_c('span',{staticClass:"kf-dash"},[_vm._v("-")]):_c('span',{staticClass:"kf-chip",class:{ 'kf-chip--sm': _vm.small },style:(_vm.chipStyle),attrs:{"title":_vm.label}},[_c('span',{staticClass:"kf-chip__dot",style:({ backgroundColor: _vm.chipColor })}),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }